module.exports = __webpack_public_path__ + "img/mark-folder-back-quote.19d1fbc.svg";